var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "indexed"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.indexed,
      expression: "indexed"
    }],
    staticClass: "icon-container indexed"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.indexedLabel,
      expression: "indexedLabel"
    }]
  }, [_vm._v("Yes")]), _c('img', {
    attrs: {
      "src": require("@/assets/success.svg")
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.indexed,
      expression: "!indexed"
    }],
    staticClass: "icon-container not-indexed"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.notIndexedLabel,
      expression: "notIndexedLabel"
    }],
    staticClass: "not-indexed"
  }, [_vm._v("No")]), _c('img', {
    attrs: {
      "src": require("@/assets/failed.svg")
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }